<script>
  import DynamicH2 from "../common/DynamicH2.svelte";

  // export let titleVisible = false;
</script>

<style>
  .outer {
    position: relative;
    width: 100%;
    height: 100%;
  }

  img {
    filter: invert(100%);
    -webkit-filter: invert(100%);
    margin-top: -70px;
    width: 650px;
    /* max-width: 100%; */
  }

  .inner {
    position: absolute;
    /* background: lightcoral; */
    font-size: 0.8rem;
    height: 405px;
    left: 21px;
    overflow: hidden;
    top: 33px;
    width: 608px;
  }

  .inner h3 {
    margin: 0;
  }

  .inner header {
    /* Shadow */
    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.5);
    padding: 2.5px 0;
  }

  .body #sidebar {
    background: rgba(255, 255, 255, 0.2);
    border-right: 0.25px solid white;
    width: 120px;
  }

  #sidebar ul {
    cursor: default;
    list-style-type: none;
    margin-top: 0.5rem;
    margin-bottom: 1rem;
    padding: 0;
  }

  #sidebar ul li {
    padding: 2.5px 0;
  }

  #sidebar ul li:hover {
    background: rgba(255, 255, 255, 0.1);
  }

  .body #inbox {
    border-right: 0.25px solid white;
    height: 100%;
    /* overflow: hidden; */
  }

  #inbox input {
    border: 0.25px solid white;
    border-radius: 2px;
    margin: 0.2rem 10px;
    text-overflow: ellipsis;
    /* Shadow */
    box-shadow: 1px 1px 3px 0 rgba(255, 255, 255, 0.5);
  }

  #inbox input::placeholder {
    color: rgba(255, 255, 255, 0.7);
  }

  #inbox .messages-wrapper {
    margin-top: 5px;
    overflow: hidden;
    overflow-y: scroll;
  }

  #inbox .inbox-message:first-of-type {
    border-top: 0.75px solid rgba(255, 255, 255, 0.5);
  }

  #inbox .inbox-message {
    /* background: lightcoral; */
    border-bottom: 0.75px solid rgba(255, 255, 255, 0.5);
    margin: 0;
    padding: 10px;
    height: 55px;
    max-height: 55px;
  }

  #message .user-info {
    border-bottom: 0.5px solid rgba(255, 255, 255, 0.5);
    height: 40px;
    padding: 0.2rem;
  }

  .user-info i {
    font-size: 2rem;
    margin-right: 5px;
  }
</style>

<div>
  <DynamicH2 inputText={'This is page number four'} />

  <!-- Laptop -->
  <div class="outer">
    <img
      src="https://cdn1.iconfinder.com/data/icons/alicons-office-equipment/32/7-512.png"
      alt="Computer" />

    <div class="inner flex-col">
      <header>
        <i class="fas fa-envelope" style="margin-left: 5px" />
        Mail
      </header>

      <div class="body flex-row flex-1">
        <div id="sidebar" class="flex-col">
          <div class="container">
            <h3>Mailboxes</h3>
            <ul>
              <li>Inbox</li>
              <li>Starred</li>
              <li>Flagged</li>
              <li>Sent</li>
              <li>Drafts</li>
              <li>Trash</li>
            </ul>

            <h3>Groups</h3>
            <ul>
              <li>Personal</li>
              <li>Important</li>
              <li>Work</li>
            </ul>
          </div>
        </div>

        <div id="inbox" class="flex-1 flex-col">
          <input
            type="text"
            class="clear-element"
            placeholder="Search your inbox" />

          <div class="messages-wrapper flex-1">
            <div class="inbox-message">Test</div>
            <div class="inbox-message">Test</div>
            <div class="inbox-message">Test</div>
            <div class="inbox-message">Test</div>
            <div class="inbox-message">Test</div>
          </div>

        </div>

        <div id="message" class="flex-2 flex-col">
          <div class="container">
            <!-- User Info -->
            <div class="user-info flex-row items-center">
              <i class="far fa-user-circle" />
              <span>
                <h3>John Doe</h3>
                <small>email@mail.com</small>
              </span>
            </div>
            <!-- End of User Info -->

            <!-- Message content -->
            <div class="flex-1">
              <p>Hey {'{{name}}'}</p>

              <p>
                Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                Eveniet, ipsam quam? Magni quod pariatur, sit saepe vel rem
                ipsum, fugiat corrupti sed soluta voluptatum quia autem tenetur.
                Labore, nemo pariatur.
              </p>

              <p>
                Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                Eveniet, ipsam quam? Magni quod pariatur, sit saepe vel rem
                ipsum, fugiat corrupti sed soluta voluptatum quia autem tenetur.
                Labore, nemo pariatur.
              </p>

              <p>Thanks</p>
              <p>John</p>
            </div>
            <!-- End of Message content -->
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
